module.exports = "/davinci/assets/c9d1b534241a7c4f90fca4f01171129a.png";